export const roundMoney = (value) => Math.round((Number(value) + Number.EPSILON) * 100) / 100;

export function calculatePOSTotals(items, discount = 0) {
  let subtotal = 0;
  const taxes = {};
  for (const item of items) {
    const qty = item.uom === "KG" ? Number(item.grams || 0) / 1000 : Number(item.qty || 0);
    const amount = roundMoney(qty * Number(item.overriddenPrice ?? item.price ?? 0));
    subtotal = roundMoney(subtotal + amount);
    for (const tax of item.taxes || []) {
      taxes[tax.name] = roundMoney((taxes[tax.name] || 0) + roundMoney(amount * Number(tax.percent) / 100));
    }
  }
  const gross = roundMoney(subtotal + Object.values(taxes).reduce((sum, value) => sum + value, 0) - roundMoney(discount));
  return { subtotal, taxes, gross, total: Math.round(gross), roundOff: roundMoney(Math.round(gross) - gross) };
}
